import { integrationId, playbookId } from '../fixture-ids';

const playbookParentRefs = [{ key: 'integrationId', entity: 'integration' }];

export const playbookEntries = {
  INTEGRATION_REVISION_CREATED: {
    entity: 'playbook',
    identity: 'record',
    idKeys: ['playbookId'],
    renderMode: 'diff',
    createsRecord: true,
    parentRefs: playbookParentRefs,
    foreignDisplayKeys: ['integrationName'],
  },
  INTEGRATION_REVISION_DISABLED: {
    entity: 'playbook',
    identity: 'record',
    idKeys: ['playbookId'],
    renderMode: 'diff',
    createsRecord: false,
    parentRefs: playbookParentRefs,
    foreignDisplayKeys: ['integrationName'],
  },
  INTEGRATION_REVISION_ENABLED: {
    entity: 'playbook',
    identity: 'record',
    idKeys: ['playbookId'],
    renderMode: 'diff',
    createsRecord: false,
    parentRefs: playbookParentRefs,
    foreignDisplayKeys: ['integrationName'],
  },
};

export const playbookFixtures = {
  INTEGRATION_REVISION_CREATED: {
    action: 'INTEGRATION_REVISION_CREATED',
    debugData: {
      playbookId,
      integrationId,
      integrationName: 'Google Analytics 4',
      revision: 1,
      commitMessage: 'Initial revision',
    },
  },
  INTEGRATION_REVISION_DISABLED: {
    action: 'INTEGRATION_REVISION_DISABLED',
    debugData: {
      playbookId,
      integrationId,
      integrationName: 'Google Analytics 4',
      revision: 1,
      disabledNote: 'Superseded by revision 2',
    },
  },
  INTEGRATION_REVISION_ENABLED: {
    action: 'INTEGRATION_REVISION_ENABLED',
    debugData: { playbookId, integrationId, integrationName: 'Google Analytics 4', revision: 1 },
  },
};
